import { Vms } from '_lib/api';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ManagePmvForm {
  vmsId: string;
  name: string;
  rsus: string[];
  id?: string;
}

const initialState: ManagePmvForm = {
  vmsId: '',
  name: '',
  rsus: [],
};

const managePmvFormReducer = createSlice({
  name: 'pmvManage',
  initialState,
  reducers: {
    vmsIdChanged(state, action: PayloadAction<string>) {
      state.vmsId = action.payload;
    },
    nameChanged(state, action: PayloadAction<string>) {
      state.name = action.payload;
    },
    rsusChanged(state, action: PayloadAction<string[]>) {
      state.rsus = action.payload;
    },
    prefillForm(_state, action: PayloadAction<Vms>) {
      const vms = action.payload;
      return {
        ...initialState,
        vmsId: vms.id,
        name: vms.enrichment?.name ?? '',
        rsus: vms.enrichment?.rsus ?? [],
        id: vms.id,
      };
    },
    prefillEnrichment(
      state,
      action: PayloadAction<{ name: string; rsus: string[] }>,
    ) {
      state.name = action.payload.name;
      state.rsus = action.payload.rsus;
    },
    resetForm(_state, _action: PayloadAction<void>) {
      return initialState;
    },
  },
});

export default managePmvFormReducer;
